import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk } from 'src/store';
import {
  loginWithCodeVerification,
  loginWithUserNameAndPassword,
  logout as logoutService,
} from '../services/authService';
import { loadAllDireitos } from '../services/direitosService';
import { UserDTO } from '../types/dtos/auth';
import { buscarAplicacoesWeb } from '../services/ambienteService';
import { AplicacoesWebDTO } from '../types/dtos/genericos';

export interface AccountState {
  user: UserDTO | null;
  direitos: string[];
  dadosPortais: AplicacoesWebDTO | null;
  type: 'cigam' | 'contato';
}

const initialState: AccountState = {
  user: null,
  direitos: [],
  dadosPortais: null,
  type: 'cigam',
};

const slice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    clearAccount(state: AccountState) {
      state.user = null;
      state.dadosPortais = null;
      state.direitos = [];
    },
    setAccount(state: AccountState, action: PayloadAction<AccountState>) {
      const { user, type, dadosPortais } = action.payload;

      state.user = user;
      state.dadosPortais = dadosPortais;
      state.type = type || 'cigam';
    },
  },
});

export const { reducer } = slice;

export const { setAccount } = slice.actions;

export const login =
  (
    userName: string,
    password: string,
    portal: string,
    codigoVerificacao?: string,
    perguntaSecreta?: number,
    respostaSecreta?: string
  ): AppThunk =>
  async (dispatch): Promise<void> => {
    dispatch(slice.actions.clearAccount());

    const user = await loginWithUserNameAndPassword(
      userName,
      password,
      portal,
      codigoVerificacao,
      perguntaSecreta,
      respostaSecreta
    );

    const userStorage = localStorage.getItem('user');
    const userData = userStorage ? JSON.parse(userStorage) : '';

    if (
      userData.CodigoMensagem &&
      (userData.CodigoMensagem === '440' || userData.CodigoMensagem === '439')
    ) {
      const direitos: any[] = [];

      dispatch(
        slice.actions.setAccount({
          user: userData,
          type: 'cigam',
          direitos,
          dadosPortais: null,
        })
      );
    } else {
      const direitos = await loadAllDireitos();
      const dadosPortais = await buscarAplicacoesWeb();

      dispatch(
        slice.actions.setAccount({
          user: user[0],
          type: 'cigam',
          direitos,
          dadosPortais,
        })
      );
    }
  };

export const loginContato =
  (
    portal: string,
    codePerson: string,
    sequence: number,
    codeVerification: string
  ): AppThunk =>
  async (dispatch): Promise<void> => {
    dispatch(slice.actions.clearAccount());

    const user = await loginWithCodeVerification(
      portal,
      codePerson,
      sequence,
      codeVerification
    );

    const direitos = await loadAllDireitos();

    dispatch(
      slice.actions.setAccount({
        user: user[0],
        type: 'cigam',
        direitos,
        dadosPortais: null,
      })
    );
  };

export const logout =
  (): AppThunk =>
  (dispatch): void => {
    logoutService();

    dispatch(slice.actions.clearAccount());
  };
